module.exports = __webpack_public_path__ + "static/media/Bio-2.cc17ca87.svg";


//////////////////
// WEBPACK FOOTER
// ./src/core/img/subject_icons/Bio-2.svg
// module id = 891
// module chunks = 21